import {
  UpgradeButton,
  useLockedAction,
} from "@components/plan-subscription-lock";
import { LogoFinderSkeleton } from "./logo-finder-skeleton";

const FEATURE = "ai-limitation.brandfetch";

export const LogoFinderRateLimit = () => {
  const { plan } = useLockedAction({ feature: FEATURE });

  return (
    <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-overflow-hidden tw-text-center">
      <div
        className="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 53.85%)",
        }}
      />

      <LogoFinderSkeleton />

      <div className="tw-absolute tw-left-1/2 tw-top-[25%] tw-z-50 tw-flex tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-flex-col tw-items-center">
        <img
          alt="No results found"
          src="/assets/images/team-branding-circle.svg"
          className="tw-mb-2 tw-size-[87px]"
        />
        <div className="tw-mb-1 tw-text-lg tw-font-bold">
          You've reached your monthly search limit
        </div>
        <div className="tw-mb-6 tw-text-[13px] tw-font-semibold">
          Upgrade now to get more queries
        </div>

        <UpgradeButton plan={plan} feature={FEATURE} size="sm" />
      </div>
    </div>
  );
};
